export const MAX_RDO_SCHEDULED_SERVICES = 30;
export const RDO_SCHEDULED_SERVICE_MAX_LENGTH = 500;

export function isScheduledServiceLimitReached(current: number): boolean {
	return current >= MAX_RDO_SCHEDULED_SERVICES;
}
